import { Link } from 'react-router-dom';

export default function GuideSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
            Learn More
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            Sugargoo Spreadsheet Complete Guides
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Dive deeper into everything you need to know about Sugargoo shopping and spreadsheets
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          <Link
            to="/sugargoo-spreadsheet-guide"
            className="group p-6 md:p-7 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-200"
          >
            <span className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-file-text-line text-lg text-primary-600"></i>
            </span>
            <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200">
              Complete Sugargoo Spreadsheet Guide
            </h3>
            <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
              A comprehensive walkthrough covering everything from finding the best Sugargoo spreadsheets to mastering product discovery and saving money on international orders.
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600 whitespace-nowrap">
              Read Guide
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </span>
          </Link>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group p-6 md:p-7 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-all duration-200"
          >
            <span className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-accent-100 flex items-center justify-center">
              <i className="ri-store-2-line text-lg text-accent-600"></i>
            </span>
            <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors duration-200">
              Visit Main Store
            </h3>
            <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
              Browse the complete Sugargoo spreadsheet collection with thousands of curated products across all fashion categories on our main website.
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-accent-600 whitespace-nowrap">
              Shop Now
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-external-link-line text-xs"></i>
              </span>
            </span>
          </a>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group p-6 md:p-7 rounded-lg bg-background-50 border border-background-200 hover:border-secondary-300 transition-all duration-200"
          >
            <span className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-secondary-100 flex items-center justify-center">
              <i className="ri-price-tag-3-line text-lg text-secondary-600"></i>
            </span>
            <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-secondary-600 transition-colors duration-200">
              Latest Deals &amp; Discounts
            </h3>
            <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
              Check out the newest product additions, seasonal collections, and exclusive discounts available through the Sugargoo spreadsheet catalog.
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-secondary-600 whitespace-nowrap">
              View Deals
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-external-link-line text-xs"></i>
              </span>
            </span>
          </a>
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/sugargoo-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            Read the Full Guide
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}